import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, ViewChild, inject } from '@angular/core'
import { InputDialogComponent, InputDialogStepComponent, StepState } from 'src/app/shared/components/input-dialog/input-dialog.component'
import { NgbProgressbar } from '@ng-bootstrap/ng-bootstrap'
import { SafePipe } from 'safe-pipe'
import { Store } from '@ngrx/store'
import { downloadArticlesRemote, downloadFinished, selectStatusState } from 'src/app/state'
import { BackEndService } from 'src/app/services/backend.service'
import { ToastService } from 'src/app/services/toast.service'
import { Dictionary } from '../filtering-search-component-base/filtering-search-types'
import { Subscription } from 'rxjs'


@Component({
    selector: 'app-download-dialog',
    imports: [
        InputDialogComponent,
        InputDialogStepComponent,
        NgbProgressbar,
        SafePipe
    ],
    templateUrl: './download-dialog.component.html',
    styleUrl: './download-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadDialogComponent implements OnDestroy {
  @ViewChild('exportExcelDialog') excelExportDialogComponent: InputDialogComponent = {} as InputDialogComponent
  @Input() set action(action: Dictionary<any>) {

    if (action['export']) {
      this.exportProgress = 50
      this.exportProgressMessage = ''
      this.excelExportDialogComponent.showModal()
      this.store.dispatch(downloadArticlesRemote({
        action
      }))
      this.downloadStartedHere = true
    }
  }

  public exportProgress = 0
  public exportProgressMessage: string = ''
  public exportDownloadURL: string = ''
  public downloadStartedHere = false

  public loading$

  private exportProgressRequest$ : null | Subscription = null

  private store = inject(Store)
  private searchService = inject(BackEndService)
  private toastService = inject(ToastService)
  private cdr = inject(ChangeDetectorRef)

  constructor() {
    this.loading$ = this.store.select(selectStatusState).subscribe(state => {
      if (state.loading && state.downloadID !== '' && this.downloadStartedHere) {
        let exportCheckCountDown = 180 * 4
        let interval = setInterval(
          () => {
            if (this.exportProgressRequest$ === null) {
              this.exportProgressRequest$ = this.searchService.downloadprogress(state.downloadID).subscribe(
                (res: any) => {
                  this.exportProgressRequest$ = null
                  this.exportProgressMessage = `${res?.response?.status} ${res.response.message}`
                  this.exportProgress = res.response.progress
                  if (this.exportProgress == 100) {
                    this.exportProgressMessage = 'Download complete'
                    this.exportDownloadURL = res.response.message.split(' ')[3]
                    this.cdr.detectChanges()
                    this.store.dispatch(downloadFinished())
                    clearInterval(interval)
                    this.downloadStartedHere = false
                    this.excelExportDialogComponent.advanceToNextStep()
                    this.toastService.show(`Click <a href="${this.exportDownloadURL}">here</a> if the file was not downloaded automatically.`, {
                      header: 'Download complete',
                      classname: 'bg-success',
                      autohide: false,
                      delay: 5000,
                    })

                  } else {
                    exportCheckCountDown--
                    if (exportCheckCountDown === 0) {
                      this.store.dispatch(downloadFinished())
                      clearInterval(interval)
                      this.downloadStartedHere = false
                      this.excelExportDialogComponent.advanceToNextStep()
                      this.toastService.show(`Download failed`, {
                        classname: 'bg-danger',
                        autohide: false,
                        delay: 5000,
                      })
                    }
                  }
                }
              )
            }
          },
          250)
      }
    })
  }

  ngOnDestroy(): void {
    this.exportProgressRequest$?.unsubscribe()
    this.loading$.unsubscribe()
  }
}
